<template>
  <div>
    <CategoryConsumptionPage
      :consumption_category_id="4"
      :showFuelGasAndDieselChart="true"
      :colors="{ primary: '#DC3544', secondary: '#DBA4A8' }"
      titleCompare="Diesel consumption compare to Fuel & Gas"
      :consumption_category="{ name: 'diesel', unit: { text: 'Gal.' } }"
    >
    </CategoryConsumptionPage>
  </div>
</template>

<script>
import CategoryConsumptionPage from '@/components/consumption/CategoryConsumptionPage';
export default {
  name: 'DieselConsumptionPage',
  components: { CategoryConsumptionPage },
};
</script>

<style scoped></style>
